import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { YES, NO } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step20: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearCommunityActivities = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("communityActivities", []);
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "hoobies",
      questionData: questions[0],
      elementType: ElementType.Checkbox,
      label:
        "¿Cuáles son las actividades que le gusta realizar en su tiempo libre y realiza por lo menos una vez a la semana?",
      checkboxStyle: {
        minWidth: "320px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "desiredHobbies",
      questionData: questions[1],
      elementType: ElementType.Checkbox,
      label: "¿Qué actividades le gustaría realizar en su tiempo libre?",
      checkboxStyle: {
        minWidth: "320px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "needs",
      questionData: questions[2],
      elementType: ElementType.Checkbox,
      label: "¿Qué le hace falta para realizarlas?",
      checkboxStyle: {
        minWidth: "320px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 3,
      formik,
      visible: true,
      questionData: questions[3],
      name: "hasCommunityActivities",
      elementType: ElementType.Radio,
      onChangeCallback: clearCommunityActivities,
      label: "¿Participa en actividades comunitarias?",
    },
    {
      key: 4,
      formik,
      label: "¿Cuáles",
      name: "communityActivities",
      elementType: ElementType.Checkbox,
      questionData: questions[3]?.subQuestions[0],
      visible: formik?.values?.hasCommunityActivities?.value === YES,
      checkboxStyle: {
        minWidth: "320px",
        margin: "0 0.5rem",
      },
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Cuéntenos sobre sus gustos y hobbies
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step20;
